import ClipboardIcon from "../images/ClipboardIcon.mjs";

/**
 * Simulation status: running is over
 * @see {GlyphIcon}
 * @see {ClipboardIcon}
 */
const AppSimStatusOverIcon = class extends ClipboardIcon {};

export default AppSimStatusOverIcon;